var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-section bill-tariff"
  }, [_c('p', {
    staticClass: "tariff-amount",
    class: {
      'editable': _vm.isEditableAmount
    },
    on: {
      "click": function click($event) {
        return _vm.onEditAmount(_vm.tariff.id);
      }
    }
  }, [_vm.isPurchaseBillTicket ? [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.displayAmountPerTicket)
    }
  }), _c('span', {
    staticClass: "ticket-count",
    domProps: {
      "textContent": _vm._s("x ".concat(_vm.transaction.ticketCount))
    }
  })] : [_c('span', {
    staticClass: "amount-wrapper",
    attrs: {
      "title": _vm.$t('change.bill.amount')
    },
    domProps: {
      "textContent": _vm._s(_vm.getDisplayAmount)
    }
  }), _c('span', {
    staticClass: "pencil"
  })]], 2), _vm.tariff.name ? _c('p', [_c('strong', [_vm._v(_vm._s(_vm.tariff.name))])]) : _vm._e(), _vm.tariff.description ? [_c('cs-spoiler', {
    attrs: {
      "background": "transparent"
    },
    model: {
      value: _vm.isShownSpoiler,
      callback: function callback($$v) {
        _vm.isShownSpoiler = $$v;
      },
      expression: "isShownSpoiler"
    }
  }, [_c('button', {
    staticClass: "icon-info",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _c('div', {
    staticClass: "tariff-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.tariff.description))])])])] : _vm._e(), _vm.tariff.subscription ? [_vm.isSubscriptionTrialDays ? _c('p', {
    directives: [{
      name: "m-y",
      rawName: "v-m-y",
      value: 4,
      expression: "4"
    }]
  }, [_c('span', {
    staticClass: "subscription-trial",
    domProps: {
      "textContent": _vm._s(_vm.displaySubscriptionTrialDays)
    }
  })]) : _vm._e(), _vm.isShownSubscriptionPer ? _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.getDisplaySubscriptionPer(_vm.tariff.subscription))
    }
  }) : _vm._e(), _vm.tariff.subscription.oneTimePayment ? _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.displayOneTimePayment)
    }
  }) : _vm._e()] : _vm._e(), _vm.isShownPromoCode ? _c('promo-code', {
    attrs: {
      "content": _vm.promoCode,
      "currency": _vm.tariff.currency
    }
  }) : _vm.isShownTransactionTips ? _c('transaction-tips', {
    attrs: {
      "currency": _vm.tariff.currency,
      "tips": _vm.transaction.transactionTips
    }
  }) : _vm._e(), _vm.tariff.contentUrl ? _c('p', {
    staticClass: "tariff-content-url"
  }, [_c('a', {
    on: {
      "click": function click($event) {
        _vm.$openLink(_vm.getDisplayContentUrl(_vm.tariff.contentUrl), true, true);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('realised.content')) + " ")])]) : _vm._e(), _vm.isBillTicket ? [_c('ticket-information', {
    directives: [{
      name: "m-top",
      rawName: "v-m-top",
      value: 8,
      expression: "8"
    }],
    attrs: {
      "tariff": _vm.tariff,
      "transaction": _vm.transaction
    }
  })] : _vm.isPurchaseBillTicket ? [_c('p', {
    staticClass: "ticket-template"
  }, [_c('base-icon', {
    directives: [{
      name: "m-r",
      rawName: "v-m-r",
      value: 5,
      expression: "5"
    }],
    attrs: {
      "size": 16,
      "name": "shopping_coupon"
    }
  }), _c('a', {
    attrs: {
      "href": _vm.transaction.ticket_link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('bill.ticket')))])], 1)] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }